export const jwUrl = (id) =>
  fetch(`https://content.jwplatform.com/v2/media/${id}`)
    .then(response => response.json())
    .then(data => {
      const videos = (data.playlist[0]?.sources || [])
        .filter(file => file.type === "video/mp4" && file.width && file.height)
        .sort((a, b) => b.width * b.height - a.width * a.height)
      return videos[0]?.file
    })
